import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAccessToken } from '../utils/authTokens';
import { isCurrentUserLibAdmin, isAdminOnlyEnabled } from '../utils/authPolicy';
import { forceLogout } from '../services/authSession';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = getAccessToken();
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (isAdminOnlyEnabled() && !isCurrentUserLibAdmin()) {
    forceLogout();
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;